import { useEffect, useState } from 'react';
import { getPage } from '@/services/about/about.service';
import { AboutPage } from '@/graphql/generated/graphql';
import DefaultContentTemplatePage from '../default-content-template';

const AboutPageComponent = () => {
  const [page, setLearnPage] = useState<AboutPage | null>(null);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const pageResponse = await getPage();

      setLearnPage(pageResponse.page);
      setLoading(false);
    })();
  }, []);

  const template = page?.DefaultContentTemplate || null;

  if (loading) {
    return null;
  }

  return (
    <>
      <DefaultContentTemplatePage template={template} title={page?.pageTitle || 'Back to the Homepage'} />
    </>
  );
};

export default AboutPageComponent;
